<template>
    <div
        class="chat-host"
        v-bind:class="{ 'chat-host--elevated': generalSidebarMobile === 'Chat' || generalDesktopChatOpen }"
    >
        <aside id="chat" v-bind:class="{ 
            'chat-open': generalSidebarMobile === 'Chat' || generalDesktopChatOpen,
            'chat-rain': generalRain.active !== null,
            'chat-desktop-closed': !generalDesktopChatOpen && generalSidebarMobile !== 'Chat'
        }">
            <div class="chat-toggle">
                <button v-on:click="toggleDesktopChat">
                    <div class="button-inner">
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.75 0H2.25C1.00736 0 0 1.00736 0 2.25V14.25C0 15.4926 1.00736 16.5 2.25 16.5H4.91251L4.50452 20.1675C4.45904 20.5792 4.75593 20.9498 5.16766 20.9953C5.38027 21.0188 5.59278 20.9503 5.75178 20.8073L10.5383 16.5H18.75C19.9926 16.5 21 15.4926 21 14.25V2.25C21 1.00736 19.9926 0 18.75 0Z" />
                        </svg>
                    </div>
                </button>
            </div>
            <div class="chat-header">
                <div v-if="chatPanelOpen" class="chat-header-top">
                    <span class="chat-header-title">Live chat</span>
                    <button type="button" class="button-close-chat" v-on:click="closeChat" aria-label="Close chat">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
                <div class="header-online" :class="{ 'is-loading': chatMessages.data === null || chatMessages.loading === true }">
                    <span class="header-status-dot" aria-hidden="true"></span>
                    <span class="header-online-text">{{ chatStatusText }}</span>
                    <p class="header-online-text">Online</p>
                </div>
                <RainTipDropdown />
            </div>
            <div class="chat-content">
                <div v-on:scroll="chatHandleScroll()" class="content-messages" ref="chatMessages">
                    <transition  name="fade" mode="out-in">
                        <div v-if="!authenticated && (chatMessages.data === null || chatMessages.loading === true)" class="messages-login-prompt" key="login-prompt">
                            <div class="prompt-content">
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24 24C28.4183 24 32 20.4183 32 16C32 11.5817 28.4183 8 24 8C19.5817 8 16 11.5817 16 16C16 20.4183 19.5817 24 24 24Z" fill="#00FFC2"/>
                                    <path d="M24 28C16.2686 28 10 33.3726 10 40V40C10 42.2091 11.7909 44 14 44H34C36.2091 44 38 42.2091 38 40V40C38 33.3726 31.7314 28 24 28Z" fill="#00FFC2"/>
                                </svg>
                                <h3>You need to login or register to see this part</h3>
                                <p>Join our community and start chatting with other players</p>
                                <div class="prompt-buttons">
                                    <button v-on:click="openSignInModal" class="btn-login">
                                        LOGIN
                                    </button>
                                    <button v-on:click="openSignUpModal" class="btn-register">
                                        REGISTER
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="chatMessages.data === null || chatMessages.loading === true" class="messages-loading" key="loading">

                            <div v-for="index in 5" v-bind:key="index" class="loading-placeholder">
                                <div class="placeholder-user">
                                    <div class="user-avatar"></div>
                                    <div class="user-info">
                                        <div class="user-username"></div>
                                        <div class="user-time"></div>
                                    </div>
                                </div>
                                <div class="placeholder-message">
                                    <div class="message-line"></div>
                                    <div class="message-line short"></div>
                                </div>
                            </div>

                        </div>
                        <div v-else class="messages-list" key="list">

                            <ChatMessageElement v-for="message in chatMessages.data" v-bind:key="message._id" v-bind:message="message" />

                        </div>
                    </transition>
                </div>
                <div class="content-lock">
                
                </div>
                <div class="content-rain">
                    <transition name="fade-slide" mode="out-in">
                        <RainJoin v-if="generalRain.active !== null" />
                    </transition>
                </div>
            </div>
            <div class="chat-footer">
                <div class="footer-input">
                    <input
                        v-model="chatMessage"
                        v-on:keyup.enter="chatMessageButton"
                        type="text"
                        placeholder="Write a message…"
                        autocomplete="off"
                        autocapitalize="sentences"
                        enterkeyhint="send"
                        aria-label="Chat message"
                    />
                    <button
                        type="button"
                        v-on:click="chatMessageButton()"
                        class="button-send"
                        v-bind:disabled="socketSendLoading !== null"
                        aria-label="Send message"
                    >
                        <IconMessage />
                    </button>
                </div>
                <div class="footer-toolbar" role="toolbar" aria-label="Chat tools">
                    <button type="button" v-on:click="modalsSetShow('ChatRules')" class="button-rules" aria-label="Open chat rules">
                        <span class="button-rules-icon" aria-hidden="true"><IconRules /></span>
                        <span>Rules</span>
                    </button>
                    <ChatEmojisDropdown />
                </div>
            </div>
        </aside>
        <div v-if="generalSidebarMobile === 'Chat'" class="mobile-backdrop" v-on:click="generalSetSidebarMobile(null)"></div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import IconUsers from '@/components/icons/IconUsers';
    import IconMessage from '@/components/icons/IconMessage';
    import IconRules from '@/components/icons/IconRules';
    import ChatMessageElement from '@/components/chat/ChatMessageElement';
    import ChatEmojisDropdown from '@/components/chat/ChatEmojisDropdown';
    import RainTipDropdown from '@/components/rain/RainTipDropdown';
    import RainJoin from '@/components/rain/RainJoin';

    export default {
        name: 'Chat',
        components: {
            IconUsers,
            IconMessage,
            IconRules,
            ChatMessageElement,
            ChatEmojisDropdown,
            RainTipDropdown,
            RainJoin
        },
        data() {
            return {
                chatMessage: ''
            }
        },
        methods: {
            ...mapActions([
                'notificationShow', 
                'modalsSetShow',
                'modalsSetData', 
                'generalSetSidebarMobile', 
                'generalSetDesktopChatOpen',
                'chatSetScroll',
                'chatGetMessagesSocket', 
                'chatSendMessageSocket',
                'chatSendClearSocket', 
                'chatSendLockSocket', 
                'generalSetUserInfoData',
                'generalGetUserInfoSocket',
                'generalSendRainCreateSocket'
            ]),
            chatScrollToBottom() {
                this.$nextTick(() => {
                    let container = this.$refs.chatMessages;
                    container.scrollTop = container.scrollHeight;
                });
            },
            chatAddEmoji(emoji) {
                this.chatMessage = this.chatMessage + emoji;
            },
            chatHandleScroll() {
                let container = this.$refs.chatMessages;
                this.chatSetScroll((container.scrollHeight - (container.scrollTop + container.clientHeight)) < 100);
            },
            chatHandleCommand(command) {
                this.generalSetUserInfoData(null);
                const args = command.split(' ');

                if(args[0] === '/tip') {
                    if(!this.authenticated) {
                        this.notificationShow({ type: 'error', message: 'Please sign in to use the tip command.' });
                        return;
                    }
                    if(args[1] === undefined || args[1].trim() === '' || args[1].match(/^[0-9a-fA-F]{24}$/) === null) {
                        this.notificationShow({ type: 'error', message: 'You need to provide a valid user id.' });
                        return;
                    }

                    const data = { userId: args[1] };
                    this.generalGetUserInfoSocket(data);
                    this.modalsSetShow('Tip');
                } else if(['/mute', '/ban'].includes(args[0]) === true && ['admin', 'mod'].includes(this.authUser?.user?.rank) === true) {
                    if(args[1] === undefined || args[1].trim() === '' || args[1].match(/^[0-9a-fA-F]{24}$/) === null) {
                        this.notificationShow({ type: 'error', message: 'You need to provide a valid user id.' });
                        return;
                    }

                    const data = { userId: args[1] };
                    this.generalGetUserInfoSocket(data);

                    if(args[0] === '/mute') { this.modalsSetShow('Mute'); } 
                    else if(args[0] === '/ban') { this.modalsSetShow('Ban'); }
                } else if(args[0] === '/rain') {
                    if(!this.authenticated) {
                        this.notificationShow({ type: 'error', message: 'Please sign in to use the rain command.' });
                        return;
                    }
                    const data = { amount: parseFloat(args[1]) };
                    this.generalSendRainCreateSocket(data);
                } else if(args[0] === '/clear') {
                    const data = {};
                    this.chatSendClearSocket(data);
                } else if(args[0] === '/lock') {
                    const data = { value: false };
                    this.chatSendLockSocket(data);
                } else if(args[0] === '/unlock') {
                    const data = { value: true };
                    this.chatSendLockSocket(data);
                }  
            },
            chatMessageButton() {
                const chatSettings = this.generalSettings?.chat;
                const userRank = this.authUser?.user?.rank;

                if (!this.authenticated) {
                    this.notificationShow({ type: 'error', message: 'Please log in to chat.' });
                    return;
                }

                if(chatSettings?.enabled === false && userRank !== 'admin') {
                    this.notificationShow({ type: 'error', message: 'Chat is unavailable right now. Please try again later.' });
                    return;
                }

                if(chatSettings?.mode === 'normal' && userRank !== 'admin' && (new Date().getTime() - this.chatLastMessage) < 3000) {
                    this.notificationShow({ type: 'error', message: 'You can only send 1 message every 3 seconds.' });
                    return;
                }

                if(chatSettings?.mode === 'slow' && userRank !== 'admin' && (new Date().getTime() - this.chatLastMessage) < 6000) {
                    this.notificationShow({ type: 'error', message: 'You can only send 1 message every 6 seconds because the chat is in slow mode.' });
                    return;
                }

                const message = this.chatMessage.trim();

                if(message === '') {
                    this.notificationShow({ type: 'error', message: 'Please enter a message.' });
                    return;
                }

                if(['/tip', '/rain'].includes(message.split(' ')[0]) === true) {
                    this.chatHandleCommand(message);
                } else if(
                    ['mod', 'admin'].includes(userRank) === true && 
                    ['/clear', '/lock', '/unlock', '/mute', '/ban'].includes(message.split(' ')[0]) === true
                ) {
                    this.chatHandleCommand(message);
                } else {
                    const data = { message: message };
                    this.chatSendMessageSocket(data);
                }

                this.chatMessage = '';
            },
            toggleDesktopChat() {
                this.generalSetDesktopChatOpen(!this.generalDesktopChatOpen);
            },
            closeChat() {
                if (this.generalSidebarMobile === 'Chat') {
                    this.generalSetSidebarMobile(null);
                }
                if (this.generalDesktopChatOpen) {
                    this.generalSetDesktopChatOpen(false);
                }
            },
            openSignInModal() {
                this.$root.$emit('open-signin-modal-app');
            },
            openSignUpModal() {
                this.$root.$emit('open-signup-modal-app');
            }
        },
        computed: {
            ...mapGetters([
                'socketSendLoading', 
                'generalSidebarMobile', 
                'generalDesktopChatOpen',
                'generalSettings', 
                'authUser',
                'authenticated',
                'chatScroll', 
                'chatRoom', 
                'chatOnline', 
                'chatMessages', 
                'chatLastMessage', 
                'generalRain'
            ]),
            chatGetOnline() {
                let online = 0;

                for(const [key, value] of Object.entries(this.chatOnline)) {
                    online = online + value;
                }

                return online;
            },
            chatStatusText() {
                const loading = this.chatMessages.data === null || this.chatMessages.loading === true;
                return loading ? 'Active' : this.chatGetOnline + 50;
            },
            /** True when the chat drawer is open (mobile sidebar or desktop panel). */
            chatPanelOpen() {
                return this.generalSidebarMobile === 'Chat' || this.generalDesktopChatOpen === true;
            }
        },
        watch: {
            'chatMessages.data': {
                handler(state, oldState) {
                    const message = this.chatMessages.data[this.chatMessages.data.length - 1];

                    if(
                        this.chatScroll === true || 
                        this.chatMessages.data.length === 0 ||
                        (this.authenticated && message !== undefined && message.type === 'user' && message.user._id === this.authUser.user._id)
                    ) {
                        setTimeout(() => { this.chatScrollToBottom(); }, 200);
                    }
                },
                deep: true
            },
            'generalRain.active': {
                handler(state, oldState) {
                    setTimeout(() => { this.chatScrollToBottom(); }, 125);
                },
                deep: true
            },
            'generalSidebarMobile': {
                handler(state, oldState) {
                    if(this.generalSidebarMobile === 'Chat') { 
                        this.chatScrollToBottom(); 
                    } else if(this.generalSidebarMobile !== null && this.generalSidebarMobile !== 'Chat') {
                        // When mobile menu is displayed (and it's not chat), close desktop chat
                        if(this.generalDesktopChatOpen) {
                            this.generalSetDesktopChatOpen(false);
                        }
                    }
                }
            }
        },
        mounted() {
            this.chatScrollToBottom();
        }
    }
</script>

<style scoped>
    /* Lift entire chat subtree above other fixed UI (e.g. live-chat FAB) while panel is open */
    .chat-host.chat-host--elevated {
        position: relative;
        z-index: 100005;
    }

    aside#chat {
        width: 300px;
        max-width: 300px;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0 !important;
        right: auto !important;
        padding: 17px 0 20px 0;
        background: var(--bg-footer-background);
        box-shadow: 3px 0px 10px rgba(0, 0, 0, 0.07);
        z-index: 50;
        transition: opacity 0.2s ease, visibility 0.2s ease;
        opacity: 1;
        visibility: visible;
        display: flex;
        flex-direction: column;
    }

    aside#chat.chat-desktop-closed {
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
    }

    aside#chat .chat-toggle {
        position: absolute;
        display: block;
        bottom: 50px;
        left: -65px;
    }

    aside#chat .chat-toggle button {
        width: 50px;
        height: 50px;
        filter: drop-shadow(0px 4px 25px rgba(1, 230, 169, 0.15)) drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.35));
    }

    aside#chat .chat-toggle button .button-inner {       
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(255deg, #00ffc2 0%, #00aa6d 75%);
        clip-path: polygon(25% 0, 75% 0, 100% 25%, 100% 75%, 75% 100%, 25% 100%, 0 75%, 0 25%);
    }

    aside#chat .chat-toggle button .button-inner svg {
        width: 19px;
        height: 19px;
        margin-top: 3px;
        fill: #ffffff;
    }

    aside#chat .chat-header {
        position: relative;
        padding: 16px 16px 0 16px;
        flex-shrink: 0;
    }

    aside#chat .chat-header-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        margin-bottom: 12px;
        padding-right: 2px;
    }

    aside#chat .chat-header-title {
        font-size: 15px;
        font-weight: 700;
        letter-spacing: 0.02em;
        color: rgba(255, 255, 255, 0.95);
    }

    aside#chat .button-close-chat {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        min-width: 40px;
        min-height: 40px;
        flex-shrink: 0;
        padding: 0;
        margin: 0;
        background: rgba(255, 255, 255, 0.06);
        border: 1px solid rgba(255, 255, 255, 0.12);
        border-radius: 10px;
        color: rgba(226, 232, 240, 0.95);
        cursor: pointer;
        transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
        touch-action: manipulation;
        -webkit-tap-highlight-color: transparent;
    }

    aside#chat .button-close-chat:hover {
        background: rgba(255, 255, 255, 0.1);
        border-color: rgba(255, 255, 255, 0.18);
        color: #00ffc2;
    }

    aside#chat .button-close-chat:focus-visible {
        outline: 2px solid rgba(0, 255, 194, 0.45);
        outline-offset: 2px;
    }

    aside#chat .button-close-chat:active {
        transform: scale(0.96);
    }

    aside#chat .header-online {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        font-weight: 700;
        gap: 10px;
        padding: 12px 16px;
        margin-top: 0;
        background: rgba(255, 255, 255, 0.04);
        border: 1px solid rgba(255, 255, 255, 0.08);
        border-radius: 12px;
    }

    aside#chat .header-status-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #00ffc2;
        flex-shrink: 0;
        box-shadow: 0 0 10px rgba(0, 255, 194, 0.6);
    }

    aside#chat .header-online.is-loading .header-status-dot {
        animation: chat-status-pulse 1.2s ease-in-out infinite;
    }

    @keyframes chat-status-pulse {
        0%, 100% { opacity: 1; box-shadow: 0 0 10px rgba(0, 255, 194, 0.6); }
        50% { opacity: 0.5; box-shadow: 0 0 4px rgba(0, 255, 194, 0.4); }
    }

    aside#chat .header-online-text {
        color: #00ffc2;
        letter-spacing: 0.3px;
    }

    aside#chat .header-online .header-users-icon {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
    }

    aside#chat .chat-content {
        width: 100%;
        flex: 1 1 auto;
        min-height: 0;
        height: auto;
        position: relative;
    }

    aside#chat .chat-content::before {
       content: '';
       width: 100%;
       height: 64px;
       position: absolute;
       top: 0;
       left: 0; 
       z-index: 2;
   }

   aside#chat .content-messages {
       height: 100%;
       padding-bottom: 15px;
       overflow-x: hidden;
       overflow-y: scroll;
       scrollbar-width: none;
       -ms-overflow-style: none;
       scroll-behavior: smooth;
       transition: height 0.3s ease;
   }

    aside#chat.chat-rain .chat-content .content-messages {
       height: calc(100% - 145px);
   }

    aside#chat .content-messages::-webkit-scrollbar-track {
        background-color: transparent;
    }

    aside#chat .content-messages::-webkit-scrollbar {
        width: 0;
        height: 0;
    }

    aside#chat .messages-loading {
        width: 100%;
        padding: 0 15px;
    }

    aside#chat .messages-loading.fade-leave-active {
        transition: opacity 0.2s;
    }

    aside#chat .messages-loading.fade-leave-to {
        opacity: 0;
    }

    aside#chat .messages-login-prompt {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 15px;
    }

    aside#chat .prompt-content {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;
    }

    aside#chat .prompt-content svg {
        width: 48px;
        height: 48px;
        filter: drop-shadow(0px 0px 10px rgba(0, 255, 194, 0.3));
    }

    aside#chat .prompt-content h3 {
        font-size: 14px;
        font-weight: 700;
        color: #ffffff;
        margin: 0;
        line-height: 1.3;
    }

    aside#chat .prompt-content p {
        font-size: 12px;
        color: #8a9ba8;
        margin: 0;
        line-height: 1.4;
    }

    aside#chat .prompt-buttons {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;
        margin-top: 10px;
    }

    aside#chat .prompt-buttons button {
        width: 100%;
        padding: 10px 15px;
        border: none;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    aside#chat .prompt-buttons .btn-login {
        background: linear-gradient(135deg, #00ffc2 0%, #00aa6d 100%);
        color: #000000;
    }

    aside#chat .prompt-buttons .btn-login:hover {
        filter: brightness(1.1);
        transform: translateY(-1px);
    }

    aside#chat .prompt-buttons .btn-register {
        background: transparent;
        border: 1px solid #00ffc2;
        color: #00ffc2;
    }

    aside#chat .prompt-buttons .btn-register:hover {
        background: rgba(0, 255, 194, 0.1);
        transform: translateY(-1px);
    }

    aside#chat .content-lock {
        position: absolute;
        bottom: 12px;
        left: 50%;
        transform: translate(-50%, 0);
    }

    aside#chat.chat-rain .content-lock {
        bottom: 157px;
        z-index: 100;
    }

    aside#chat .content-lock button.button-lock {
        height: 30px;
        position: relative;
        padding: 1px;
        filter: drop-shadow(0px 2px 10px rgba(1, 230, 169, 0.15)) drop-shadow(0px 4px 25px rgba(15, 41, 63, 0.35));
        z-index: 1;
    }

    aside#chat .content-lock button.button-lock::before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #01e1a4 100%);
        clip-path: polygon(7px 0, calc(100% - 7px) 0, 100% 25%, 100% 75%, calc(100% - 7px) 100%, 7px 100%, 0 75%, 0 25%);
        z-index: -1;
    }

    aside#chat .content-lock button.button-lock .button-inner {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        padding: 0 15px;
        font-size: 10px;
        font-weight: 700;
        color: #ffffff;
        background: linear-gradient(90deg, rgba(0, 0, 0, 0.128) 0%, rgba(0, 33, 24, 0.132) 25%, rgba(0, 99, 73, 0.144986) 60%, rgba(1, 193, 143, 0.0925409) 80%, rgba(1, 237, 176, 0.068) 100%) #064552;
        clip-path: polygon(7px 0, calc(100% - 7px) 0, 100% 25%, 100% 75%, calc(100% - 7px) 100%, 7px 100%, 0 75%, 0 25%);
    }

    aside#chat .content-rain {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 15px 15px 0 15px;
        z-index: 1;
    }

    aside#chat .content-rain .fade-slide-enter-active,
    aside#chat .content-rain .fade-slide-leave-active {
         transition: all 0.3s ease;
    }

    aside#chat .content-rain .fade-slide-enter,
    aside#chat .content-rain .fade-slide-leave-to {
        transform: translateY(-30px);
        opacity: 0;
    }

    aside#chat .loading-placeholder {
        width: 100%;
        margin-top: 12px;
        padding: 12px 0;
        border-bottom: 1px solid rgba(255, 193, 7, 0.15);
        animation: fadeIn 0.6s ease;
    }

    aside#chat .loading-placeholder:first-of-type {
        margin-top: 0;
    }

    aside#chat .placeholder-user {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        margin-bottom: 8px;
    }

    aside#chat .user-avatar {
        width: 35px;
        height: 35px;
        min-width: 35px;
        position: relative;
        border-radius: 50%;
        overflow: hidden;
        background: linear-gradient(135deg, #1a3a3a 0%, #0f5f52 100%);
    }

    aside#chat .user-avatar::after {
        width: 100%;
        height: 100%;
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        animation-name: shimmer;
        animation-duration: 2s;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
        background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.1) 50%, transparent 100%);
    }

    aside#chat .user-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    aside#chat .user-username {
        width: 80px;
        height: 16px;
        border-radius: 4px;
        background: linear-gradient(135deg, #1a3a3a 0%, #0f5f52 100%);
        position: relative;
        overflow: hidden;
    }

    aside#chat .user-username::after {
        width: 100%;
        height: 100%;
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        animation-name: shimmer;
        animation-duration: 2s;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
        background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.1) 50%, transparent 100%);
    }

    aside#chat .user-time {
        width: 50px;
        height: 12px;
        border-radius: 3px;
        background: linear-gradient(135deg, #1a3a3a 0%, #0f5f52 100%);
        position: relative;
        overflow: hidden;
    }

    aside#chat .user-time::after {
        width: 100%;
        height: 100%;
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        animation-name: shimmer;
        animation-duration: 2s;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
        background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.1) 50%, transparent 100%);
    }

    aside#chat .placeholder-message {
        display: flex;
        flex-direction: column;
        gap: 6px;
        margin-left: 45px;
    }

    aside#chat .message-line {
        width: 100%;
        height: 14px;
        border-radius: 4px;
        background: linear-gradient(135deg, #1a3a3a 0%, #0f5f52 100%);
        position: relative;
        overflow: hidden;
    }

    aside#chat .message-line.short {
        width: 70%;
    }

    aside#chat .message-line::after {
        width: 100%;
        height: 100%;
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        animation-name: shimmer;
        animation-duration: 2s;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
        background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.1) 50%, transparent 100%);
    }

    @keyframes fadeIn {
        from {
            opacity: 0.6;
        }
        to {
            opacity: 1;
        }
    }

    aside#chat .messages-list {
        width: 100%;
        height: 100%;
    }

    aside#chat .messages-list.fade-enter-active {
        transition: opacity 0.1s;
    }

    aside#chat .messages-list.fade-enter-from {
        opacity: 0;
    }

    aside#chat .chat-footer {
        width: 100%;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: stretch;
        padding: 14px 14px 16px;
        border-top: 1px solid rgba(255, 255, 255, 0.08);
        background: linear-gradient(180deg, rgba(31, 20, 69, 0.4) 0%, rgba(31, 20, 69, 0.95) 100%);
    }

    aside#chat .footer-input {
        width: 100%;
        min-height: 48px;
        height: 48px;
        position: relative;
        padding: 0;
        background: rgba(19, 31, 48, 0.65);
        border-radius: 12px;
        border: 1px solid rgba(85, 158, 228, 0.35);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    aside#chat .footer-input:focus-within {
        border-color: rgba(0, 255, 194, 0.45);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06), 0 0 0 1px rgba(0, 255, 194, 0.12);
    }

    aside#chat .footer-input input {
        width: 100%;
        height: 100%;
        padding: 0 52px 0 14px;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        background: transparent;
        border-radius: 12px;
        border: none;
        outline: none;
    }

    aside#chat .footer-input input::placeholder {
        color: rgba(148, 163, 184, 0.85);
    }

    aside#chat .footer-input button.button-send {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 50%;
        right: 6px;
        transform: translate(0, -50%);
        width: 38px;
        height: 38px;
        min-width: 38px;
        min-height: 38px;
        background: linear-gradient(135deg, #5c1d8b 0%, #6b4dc4 100%);
        border-radius: 10px;
        border: 1px solid rgba(255, 255, 255, 0.12);
        cursor: pointer;
        color: #ffffff;
        transition: transform 0.15s ease, filter 0.15s ease, opacity 0.15s ease;
        touch-action: manipulation;
        -webkit-tap-highlight-color: transparent;
    }

    aside#chat .footer-input button.button-send:hover:not(:disabled) {
        filter: brightness(1.08);
    }

    aside#chat .footer-input button.button-send:active:not(:disabled) {
        transform: translate(0, -50%) scale(0.96);
    }

    aside#chat .footer-input button.button-send:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    aside#chat .footer-input button.button-send:focus-visible {
        outline: 2px solid rgba(0, 255, 194, 0.5);
        outline-offset: 2px;
    }

    aside#chat .footer-toolbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        gap: 12px;
    }

    aside#chat .footer-toolbar button.button-rules {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0.02em;
        color: rgba(255, 255, 255, 0.88);
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 10px;
        padding: 10px 14px;
        min-height: 44px;
        cursor: pointer;
        transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
        touch-action: manipulation;
        -webkit-tap-highlight-color: transparent;
    }

    aside#chat .footer-toolbar button.button-rules:hover {
        background: rgba(255, 255, 255, 0.08);
        border-color: rgba(255, 255, 255, 0.16);
        color: #ffffff;
    }

    aside#chat .footer-toolbar button.button-rules:focus-visible {
        outline: 2px solid rgba(0, 255, 194, 0.45);
        outline-offset: 2px;
    }

    aside#chat .footer-toolbar .button-rules-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        opacity: 0.95;
    }

    aside#chat .footer-toolbar .button-rules-icon svg {
        display: block;
    }

    @keyframes shimmer {
        0% { transform: translateX(-100%); }
        50% { transform: translateX(100%); }
        100% { transform: translateX(100%); }
    }

    /* Desktop chat behavior - for all screens above 1024px */
    @media only screen and (min-width: 1025px) {
        aside#chat {
            top: 80px;
            height: calc(100% - 80px);
            left: 0 !important;
            right: auto !important;
            transform: none !important;
            opacity: 1;
            visibility: visible;
            transition: opacity 0.2s ease, visibility 0.2s ease;
            z-index: 121;
        }

        aside#chat.chat-open {
            opacity: 1;
            visibility: visible;
            pointer-events: auto;
        }
        
        /* Desktop chat uses generalDesktopChatOpen, not mobile sidebar */
        aside#chat.chat-desktop-closed {
            opacity: 0;
            visibility: hidden;
            pointer-events: none;
        }

        aside#chat .chat-toggle {
            display: none;
        }

        aside#chat.chat-open .chat-toggle {
            display: none;
        }
    }

    /* Mobile backdrop */
    .mobile-backdrop {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: 99999;
        display: none;
    }

    /* Position chat above bottom header on mobile and tablet, similar to sidebar */
    @media only screen and (max-width: 1024px) {
        aside#chat {
            position: fixed !important;
            /* Use top + bottom instead of 100vh height: mobile browsers treat 100vh as the *large*
               viewport, so calc(100vh - X) often makes the panel taller than the *visible* area and
               clips the top (close button / header). Safe-area avoids notch / status overlap. */
            top: env(safe-area-inset-top, 0px) !important;
            bottom: 72px !important; /* match .bottom-nav height (72px) */
            right: 0 !important;
            left: auto !important;
            width: 100% !important;
            max-width: 300px !important;
            height: auto !important;
            max-height: none !important;
            opacity: 1 !important;
            visibility: visible !important;
            transition: opacity 0.2s ease, visibility 0.2s ease !important;
            z-index: 100001 !important;
            box-sizing: border-box !important;
        }

        aside#chat.chat-open {
            opacity: 1 !important;
            visibility: visible !important;
            pointer-events: auto !important;
        }
        
        /* Override desktop-closed class on mobile/tablet */
        aside#chat.chat-desktop-closed {
            opacity: 0 !important;
            visibility: hidden !important;
            pointer-events: none !important;
        }

        .mobile-backdrop {
            display: block;
        }
    }

    @media only screen and (max-width: 768px) {
        aside#chat {
            max-width: 280px !important;
        }
    }

    /* Desktop chat toggle - only show on larger screens */
    @media only screen and (min-width: 1501px) {
        aside#chat .chat-toggle {
            display: none;
        }
    }

    @media only screen and (max-width: 9600px) {

        aside#chat .chat-toggle {
            display: none;
        }

    }

    @media only screen and (max-width: 500px) {

        aside#chat {
            width: 100%;
        }

    }
</style>



